import { EditModalComponent } from "./edit-modal/edit-modal.component";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FondsPropresService } from "./../../services/fonds-propres.service";
import { ParametreGeneral } from "./../../models/ParametreGeneral";
import { Component, OnInit, ViewChild } from "@angular/core";

@Component({
  selector: "app-parametre-general",
  templateUrl: "./parametre-general.component.html",
  styleUrls: ["./parametre-general.component.scss"],
})
export class ParametreGeneralComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: false })
  sort: MatSort;
  dataSource: MatTableDataSource<ParametreGeneral>;
  isLoadingResults = true;

  displayedColumns = [
    "id",
    "codeParametre",
    "libelleParametre",
    "valeurParametre",
    "typeParametre",
    "actions",
  ];
  data: ParametreGeneral[] = [];

  constructor(
    private shared: FondsPropresService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getParametreGenerals();
  }

  getParametreGenerals() {
    this.shared.getParametreGenerals().subscribe(
      (data) => {
        this.data = data;
      },
      (error) => {
        console.log(error);
        this.isLoadingResults = false;
      },
      () => {
        if (this.data == null) {
          this.data = [];
        }

        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isLoadingResults = false;
      }
    );
  }

  //row in modal popup
  EditerParametreGeneral(row) {
    const modalRef = this.modalService.open(EditModalComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      scrollable: true,
      windowClass: "my-app-modal-class",
    });
    modalRef.componentInstance.parametreGeneral = row;

    modalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
        this.getParametreGenerals();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }
}
